module.exports = __webpack_public_path__ + "bcb5cd1fc3100a879cc027c75706d0b3.jpg";